import React from 'react'
import { useNavigate } from 'react-router-dom';

const Verifyemail = () => {
    const navigate = useNavigate();


    const gohome = () => {
        navigate(`/login`);
        window.location.reload();
        }


  return (
    <div className="mailverif-container">
    <h1 className="mailverif-title">Verify Your Email</h1>
    <p className="mailverif-message">Please check your mailbox and click on the verification link to confirm your email address.</p>
    <button className="mailverif-button" onClick={gohome}>go to Login</button>
  </div>
  )
}

export default Verifyemail
